import { render, staticRenderFns } from "./type.vue?vue&type=template&id=20806ad4"
import script from "./type.vue?vue&type=script&lang=js"
export * from "./type.vue?vue&type=script&lang=js"
import style0 from "./type.vue?vue&type=style&index=0&id=20806ad4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports